import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator', 'campaign_manage'],
};

const whatsappMeta = {
  ...meta,
  featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          name: 'campaigns_whatsapp_index',
          meta: whatsappMeta,
          component: WhatsAppCampaignsPage,
        },
        {
          path: ':pathMatch(.*)*',
          redirect: to => ({
            name: 'campaigns_whatsapp_index',
            params: to.params,
          }),
        },
      ],
    },
  ],
};

export default campaignsRoutes;
